window.bundleCartPreview = (() => {
    const cartRow = ".cart__row";
    const cartContainer = "#CartProducts";
    const bundleRemove = ".cart-bundle-remove";
    const minicartItem = ".mini-cart-item";
    const minicartContainer = ".js-mini-cart-content";
    const miniCartRemove = ".bundle-mini-cart-remove";
    const productCount = ".js-cart-count";
    const cartCheckoutBtn = ".checkout-submit-btn-wrapper";

    const apollo = {
        items: window.bundlePreviewItems ?? [],
        hideRegularItemsWithBundle: function () {
            const bundleItemKeys = this.items
                .map(item => item.key);

            bundleItemKeys.forEach(key => {
                $(`${cartRow}[data-key='${key}']`).hide();
                $(`${minicartItem}[data-key='${key}']`).hide();
            });
            $(`${cartRow}[data-is_bundle_item='true']`).hide();
        },
        returnPreparationData: function (actionId, image, title, price, linePrice, originalLinePrice, discounts, items, line, vendor = null, url = null) {
            const customTags = [];
            const sellingPlan = items[0]?.selling_plan_allocation?.selling_plan;
            const isSubscription = sellingPlan?.recurring_deliveries;
            if (isSubscription) {
                customTags.push("Subscription");
                if (sellingPlan.name) {
                    customTags.push(sellingPlan.name)
                }
            }else{
                // customTags.push("One time purchase");
            }
            return {
                key: actionId,
                line: line,
                url: url,
                img: image,
                name: title,
                customTags: customTags,
                bundleProducts: items.map(item => ({
                    title: item.title,
                    quantity: item.quantity,
                    image: item.image?.replace('http:', '')?.replace(/(\.[^.]*)$/, '_compact$1') ?? '',
                })),
                variation: null,
                properties: {},
                itemQty: 1,

                price: theme.Currency.formatMoney(price, theme.moneyFormat),
                vendor: vendor,
                linePrice: theme.Currency.formatMoney(
                    linePrice,
                    theme.moneyFormat
                ),
                originalLinePrice: theme.Currency.formatMoney(
                    originalLinePrice,
                    theme.moneyFormat
                ),
                discounts: discounts,
                discountsApplied:
                    linePrice === originalLinePrice ? false : true
            }
        },
        prepareBundleItems: function () {
            const presetItems = this.items.filter(item => item.properties && item.properties._preset_bundle_item);
            const regularBundleItems = this.items.filter(item => item.properties && item.properties._bundle_item && !item.properties._preset_bundle_item);

            const groupedPresetItems = presetItems.reduce((acc, item) => {
                const bundleActionId = item.properties._preset_bundle_action_id;
                if (!acc[bundleActionId]) {
                    acc[bundleActionId] = [];
                }
                acc[bundleActionId].push(item);
                return acc;
            }, {});
            const groupedBundleItems = regularBundleItems.reduce((acc, item) => {
                const bundleActionId = item.properties._bundle_action_id;
                if (!acc[bundleActionId]) {
                    acc[bundleActionId] = [];
                }
                acc[bundleActionId].push(item);
                return acc;
            }, {});

            const data = [];
            let index = 1;
            for (const bundleId in groupedPresetItems) {
                const items = groupedPresetItems[bundleId];
                items.sort((a, b) => {
                    return (a.properties._product_position_order || 0) - (b.properties._product_position_order || 0);
                });
                const image = items[0].properties._preset_bundle_image?.replace('http:', '') ?? '';
                const title = items[0].properties._preset_bundle_title ?? '';
                const price = items.reduce((sum, item) => sum + item.price, 0);
                const linePrice = items.reduce((sum, item) => sum + item.line_price, 0);
                const originalLinePrice = items.reduce((sum, item) => sum + item.original_line_price, 0);
                const discounts = items.flatMap(item => item.discounts);
                const uniqueDiscounts = [
                ...new Map(discounts.map(item => [item.title, item])).values()
                ];
                // console.log("all discounts", uniqueDiscounts)
                data.push(this.returnPreparationData(
                    items[0].properties._preset_bundle_action_id,
                    image,
                    title,
                    price,
                    linePrice,
                    originalLinePrice,
                    uniqueDiscounts,
                    items,
                    index,
                    null,
                    `/products/${items[0].properties._preset_bundle_handle}`
                ));
                index++;
            }

            for (const bundleId in groupedBundleItems) {
                const items = groupedBundleItems[bundleId];
                items.sort((a, b) => {
                    return (a.properties._product_position_order || 0) - (b.properties._product_position_order || 0);
                });
                const image = '//cdn.shopify.com/s/files/1/0786/3101/0525/files/bundle.webp?v=1763034644';

                const title = $(cartContainer).data('bundle_title') || 'Custom Bundle';
                const price = items.reduce((sum, item) => sum + item.price, 0);

                const linePrice = items.reduce((sum, item) => sum + item.line_price, 0);
                const originalLinePrice = items.reduce((sum, item) => sum + item.original_line_price, 0);
                const discounts = items.flatMap(item => item.discounts);
                data.push(this.returnPreparationData(
                    items[0].properties._bundle_action_id,
                    image,
                    title,
                    price,
                    linePrice,
                    originalLinePrice,
                    discounts,
                    items,
                    index,
                ));
                index++;
            }
            return data;
        },
        renderMiniCartBundles: function () {
            this.hideRegularItemsWithBundle();
            const data = this.prepareBundleItems();
            let html = '';
            data.forEach(item => {
                html += `
                <div class="mini-cart-item bundle-prod" data-key="${item.key}">
                    <a class="mini-cart-image" href="#">
                        <img src="${item.img}">
                    </a>
                    <div class="mini-cart-meta">
                        <p><a href="#">${item.name}</a></p>
                        <div class="d-flex flex-column mb-2" style="gap:2px;">
                            ${item.bundleProducts.map(prod => `<span style="font-size: 11.2px;font-weight:500;color: var(--color-body-text);line-height:1.3;">${prod.title} <b>x${prod.quantity}</b></span>`).join('')}
                        </div>
                        <span>${item.linePrice}</span>
                    </div>
                    <button class="btn js-remove-mini-cart bundle-mini-cart-remove" data-id="${item.id}" data-action="${item.key}">×</button>
                </div>
                `;
            });
            $(minicartContainer).prepend(html);
        },
        renderBundles: function () {
            this.hideRegularItemsWithBundle();
            const source = $('#CartProductTemplate').html();
            const template = Handlebars.compile(source);

            const items = this.prepareBundleItems();
            $(cartContainer).prepend(template({ items }))
        },
        removeBundle: async function (btnSelector, shouldReload = true) {
            const actionId = $(btnSelector).attr('data-action');
            const filteredItems = this.items
                .filter(item => (item.properties && (item.properties._bundle_action_id === actionId || item.properties._preset_bundle_action_id === actionId)));
            const bundleItemKeys = filteredItems.map(item => item.key);
            let removedQty = 0;
            if (bundleItemKeys.length === 0) {
                console.error('No bundle items found for action ID:', actionId);
                return;
            }
            let loader = `<div class="spinner-border" style="height: 15px; width: 15px;border-width: 2px;color: var(--g-main);" role="status"><span class="sr-only">Loading...</span></div>`;
            $(btnSelector).html(loader);
            await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    updates: bundleItemKeys.reduce((acc, key) => {
                        acc[key] = 0;
                        return acc;
                    }, {})
                })
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Bundle removed successfully:', data);
                    removedQty = filteredItems.reduce((sum, item) => sum + item.quantity, 0);
                    $(productCount).each(function(){
                        console.log($(this).text(), $(this));
                        $(this).text(parseInt($(this).text()) - removedQty);
                    })

                    if (shouldReload) {
                        window.location.reload();
                    }
                })
                .catch((error) => {
                    console.error('Error removing bundle:', error);
                }).finally(() => {
                    $(btnSelector).html($(btnSelector).attr("data-text"));
                })
            return removedQty;
        },
        listenToMiniCartUpdates: function (cart) {
            $(`${minicartItem}.bundle-prod`).remove();
            const items = cart.items.filter(item => item.properties && (item.properties._bundle_item || item.properties._preset_bundle_item));
            this.items = items;
            apollo.renderMiniCartBundles(cart);
        }
    }

    if (apollo.items.length > 0) {
        apollo.renderBundles();
    }
    window.removeBundleFromMiniCart = async function (btnSelector) {
        await apollo.removeBundle(btnSelector, false);
    }
    document.addEventListener("click", async function (e) {
        if (!e.target.closest(bundleRemove)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        const btn = e.target.closest(bundleRemove);
        await apollo.removeBundle(btn);
        $(btn).parent(minicartItem).remove();
    }, true);

    $(cartCheckoutBtn).on("click", function(){
        if($(this).parent().find("#dsDatePikerBlock").length && !$(this).find(".btn-cart-checkout").hasClass("ds-disable-opacity")){
            let loader = `<div class="spinner-border" style="height: 15px; width: 15px;border-width: 2px;color: inherit;" role="status"><span class="sr-only">Loading...</span></div>`;
            $(this).find(".btn-cart-checkout").html(loader).prop("disabled", true);
        }
    })

    Shopify.getCart(function (cart) {
        apollo.listenToMiniCartUpdates(cart);
    });
    window.postUpdateMiniCart = (cart) => {
        apollo.listenToMiniCartUpdates(cart);
    };
    return apollo;
})()